import Typography, {  TypographyProps } from "@mui/material/Typography";
import React from "react";

interface FdProps extends TypographyProps {
  children?: React.ReactNode;
  label?:string | React.ReactNode;
}

const FdTypography = ({
  label,
  children,
  ...rest
}: FdProps): JSX.Element => {
  return (
    <Typography {...rest}>
      {label}
      {children}
    </Typography>
  );
};
export default FdTypography;
